import React, { useContext }  from 'react';
import './header-single-page.less';
import { NavLink } from 'react-router-dom';
import { Button } from '../../../components';
import { uyeGirisiKayitOlEvent} from 'utils/fb-pixel-code-event';

const HeaderWithoutAuth = () => {

  return (
    <nav className="single-page-nav">
      <NavLink to="/nasil-calisir" activeClassName="active">Nasıl Çalışır?</NavLink>
      <NavLink to="/iys-nedir" activeClassName="active">İYS Nedir?</NavLink>
      <NavLink to="/paketler" activeClassName="active">Paketler ve Ödemeler</NavLink>
      <NavLink to="/Login">
        <Button
          shape="round"
          type="ghost"
          onClick={()=>{
            uyeGirisiKayitOlEvent();
          }}
        >
          Üye Girişi / Kayıt Ol
        </Button>
      </NavLink>
    </nav>
  )
};

export default HeaderWithoutAuth;
